import { HttpStatus } from "../constants/HttpStatus";
import env from "../utils/env";
import axios from "axios";

const baseURL = env.api;
export class APIRequest {
  _refreshTokenOptions = {
    url: "",
    refreshToken: "",
    callbacks: { success: (data) => {}, error: (error) => {} },
  };

  constructor(refreshTokenOptions = {}, errorHandlingOptions = {}) {
    this._errorHandlingOptions = errorHandlingOptions;
    this.setRefreshTokenOptions(refreshTokenOptions);
    this._authToken = null;
  }

  createHeader = (token) => {
    const header = {
      //"Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
    };

    if (token) {
      header["Authorization"] = `Bearer ${token}`;
    }

    return header;
  };

  createRequest = (
    method,
    requestUrl,
    token,
    payload = null,
    shouldCallBack = true,
    config = {},
  ) => {
    const request = (token, shouldCallBack) => {
      const header = this.createHeader(token || this._authToken);

      const httpClient = axios.create({
        baseURL: baseURL,
        headers: header,
      });
      let action = httpClient;

      switch (method) {
        case "GET":
          action = httpClient.get(requestUrl, config);
          break;

        case "POST":
          action = httpClient.post(requestUrl, payload, config); // config اضافه شد
          break;

        case "PUT":
          action = httpClient.put(requestUrl, payload, config);
          break;

        case "DELETE":
          action = httpClient.delete(requestUrl, { data: payload, ...config });
          break;

        case "PATCH":
          action = httpClient.patch(requestUrl, payload, config);
          break;

        default:
          break;
      }

      return action
        .then((response) => response)
        .catch(shouldCallBack ? this._handleError(request) : (error) => error);
    };

    return request(token, shouldCallBack);
  };

  setRefreshTokenOptions = (refreshTokenOptions) => {
    this._refreshTokenOptions.url = refreshTokenOptions?.url;
    this._refreshTokenOptions.refreshToken = refreshTokenOptions?.refreshToken;
    this._refreshTokenOptions.callbacks = refreshTokenOptions?.callbacks;
  };

  setErrorHandlingOptions = (errorHandlingOptions = {}) =>
    (this._errorHandlingOptions = errorHandlingOptions);

  setAuthToken = (token) => {
    this._authToken = token;
  };

  getNewTokenInfo = async () => {
    const response = await this.createRequest(
      "POST",
      this._refreshTokenOptions.url,
      null,
      {
        refreshToken: this._refreshTokenOptions.refreshToken,
      },
      false,
    );

    if (isSuccessStatus(response?.status)) {
      if (typeof this._refreshTokenOptions.callbacks?.success === "function") {
        this._refreshTokenOptions.callbacks.success(response?.data);
      }
      return response.data?.token;
    }

    if (typeof this._refreshTokenOptions.callbacks?.error === "function") {
      this._refreshTokenOptions.callbacks.error(response?.error);
    }
    return null;
  };

  _handleError(callbackRequest) {
    return async (error) => {
      if (error.response) {
        const { status, data } = error.response;

        switch (status) {
          case HttpStatus.UNAUTHORIZED:
            if (
              typeof this._errorHandlingOptions?.[HttpStatus.UNAUTHORIZED] ===
              "function"
            ) {
              this._errorHandlingOptions?.[HttpStatus.UNAUTHORIZED]();
            }
            break;

          case HttpStatus.BAD_REQUEST:
            if (
              typeof this._errorHandlingOptions?.[HttpStatus.BAD_REQUEST] ===
              "function"
            ) {
              this._errorHandlingOptions?.[HttpStatus.BAD_REQUEST](
                data?.FailedMessages
                  ? data?.FailedMessages[0]
                  : data?.failedMessages
                    ? data?.failedMessages[0]
                    : data,
              );
            }
            break;

          case HttpStatus.INTERNAL_SERVER_ERROR:
            if (
              typeof this._errorHandlingOptions?.[
                HttpStatus.INTERNAL_SERVER_ERROR
              ] === "function"
            ) {
              this._errorHandlingOptions?.[HttpStatus.INTERNAL_SERVER_ERROR](
                data?.FailedMessages
                  ? data?.FailedMessages[0]
                  : data?.failedMessages
                    ? data?.failedMessages[0]
                    : data,
              );
            }
            break;

          case HttpStatus.NOT_FOUND:
            if (
              typeof this._errorHandlingOptions?.[HttpStatus.NOT_FOUND] ===
              "function"
            ) {
              this._errorHandlingOptions?.[HttpStatus.NOT_FOUND](data);
            }
            break;

          default:
            break;
        }

        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    };
  }

  /* GET = (requestUrl, token) => this.createRequest("GET", requestUrl, token);

  POST = (requestUrl, token, payload) =>
    this.createRequest("POST", requestUrl, token, payload);

  PUT = (requestUrl, token, payload) =>
    this.createRequest("PUT", requestUrl, token, payload);

  DELETE = (requestUrl, token, payload) =>
    this.createRequest("DELETE", requestUrl, token, payload);

  PATCH = (requestUrl, token, payload) =>
    this.createRequest("PATCH", requestUrl, token, payload); */
  GET = (requestUrl, token, config = {}) =>
    this.createRequest("GET", requestUrl, token, null, true, config);

  POST = (requestUrl, token, payload, config = {}) =>
    this.createRequest("POST", requestUrl, token, payload, true, config);

  PUT = (requestUrl, token, payload, config = {}) =>
    this.createRequest("PUT", requestUrl, token, payload, true, config);

  DELETE = (requestUrl, token, payload, config = {}) =>
    this.createRequest("DELETE", requestUrl, token, payload, true, config);

  PATCH = (requestUrl, token, payload, config = {}) =>
    this.createRequest("PATCH", requestUrl, token, payload, true, config);
}

export const request = new APIRequest();

export var isSuccessStatus = function isSuccessStatus(status) {
  return [
    HttpStatus.SUCCESS,
    HttpStatus.CREATED_SUCCESS,
    HttpStatus.NO_CONTENT,
    HttpStatus.ACCEPTED,
  ].includes(status);
};
